import { render, staticRenderFns } from "./SMSTask.vue?vue&type=template&id=7206fdf7&"
import script from "./SMSTask.vue?vue&type=script&lang=js&"
export * from "./SMSTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports